import { render, staticRenderFns } from "./my_receipts.vue?vue&type=template&id=5d8977be&scoped=true&"
import script from "./my_receipts.vue?vue&type=script&lang=js&"
export * from "./my_receipts.vue?vue&type=script&lang=js&"
import style0 from "./my_receipts.vue?vue&type=style&index=0&id=5d8977be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8977be",
  null
  
)

export default component.exports